import { webDataApi } from "@/apis/home-api";
import ErrorPage from "@/components/ErrorPage";
import Loading from "@/components/Loading";
import { AppContext } from "@/contexts/app-context";
import { NotifContext } from "@/contexts/notif-context";
import { ShopContext } from "@/contexts/shop-context";
// import { appContextData } from "@/seeders/apiSeeder";
import type { AppContextType } from "@/types/context-type";
import type { ProductDetailType } from "@/types/shop-type";
import type { AlertType, ChildrenType, LocaleTextType } from "@/types/types";
import { useEffect, useState } from "react";

export default function AppsContext({ children }: ChildrenType) {
    const [isLoading, setIsLoading] = useState(true);

    // context
    const [app, setApp] = useState<AppContextType | null>(null);
    const [notif, setNotif] = useState<AlertType | null>(null);
    const [product, setProduct] = useState<ProductDetailType[] | null>(null);
    const [category, setCategory] = useState<LocaleTextType[] | null>(null);

    useEffect(() => {
        const initializeApp = async () => {
            try {
                const response = await webDataApi();
                setApp(response);
            } catch (error) {
                console.error("Failed initialize app context:", error);
            } finally {
                setIsLoading(false);
            }
        };

        initializeApp();
    }, []);

    if (isLoading) {
        return <Loading />;
    }

    if (!app) {
        return <ErrorPage />;
    }

    return (
        <AppContext.Provider value={{ app, setApp }}>
            <NotifContext.Provider value={{ notif, setNotif }}>
                <ShopContext.Provider
                    value={{ product, setProduct, category, setCategory }}>
                    {children}
                </ShopContext.Provider>
            </NotifContext.Provider>
        </AppContext.Provider>
    );
}
